import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => {
    return {
        tableHeaderClass: {
            "& th": {
                background: theme.palette.blue[9],
                color: theme.palette.text.primary,
                fontWeight: "bold",
                "& span": {
                    color: "inherit",
                    "&:hover": {
                        color: "inherit"
                    }
                },
            }
        },
    };
});
